import React from 'react'
import { LazyRouteFunction, RouteObject } from 'react-router-dom'

export const componentCache = new Map<
  LazyRouteFunction<RouteObject>,
  React.ComponentType<TSFixMe>
>()
